import React from 'react';
import ClientInfoView from './ClientInfoView/ClientInfoView';
import { useMeter8000Data} from '../../hooks/useMeter';

interface ClientInfoPresenterProps {
  deviceId: string;
}

export default function ClientInfoPresenter({ deviceId }: ClientInfoPresenterProps) {

  const { getClient8000ByMeterIdQuery, getMeterInfoLocalizationByMeterIdQuery, } = useMeter8000Data(deviceId);
 

  // Données client - localisation via getMeterInfoLocalizationByMeterId
  const clientInfo = {
    firstName: getClient8000ByMeterIdQuery.data?.name,
    lastName: "",
    location: getMeterInfoLocalizationByMeterIdQuery.data?.minigridName,
    latitude: getMeterInfoLocalizationByMeterIdQuery.data?.lattitude,
    longitude: getMeterInfoLocalizationByMeterIdQuery.data?.longitude,
  };

  return (
    <ClientInfoView
      clientInfo={clientInfo}
      deviceId={deviceId}
      isLoading={getClient8000ByMeterIdQuery.isLoading || getMeterInfoLocalizationByMeterIdQuery.isLoading}
      isError={getClient8000ByMeterIdQuery.isError}
      error={getClient8000ByMeterIdQuery.error}
    />
  );
}
